import { Component } from '@angular/core';
import { BaseDetailsPanelComponent, convertDate } from '../../base-details-panel/base-details-panel.component';
import { DetailsElementData, ElementDataDetail, LijstElementData, Medewerker, MedewerkerDetail } from '../../Details';
import { Attr } from '@cumlaude/metadata';
import { BasicFilterExpression, CompoundFilterExpression, FilterExpression, ListOptions, TableResponse } from '../../../services/data.service';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { attrLabel, roepAchternaam } from '../../../services/labels';
import { SvgSpinnerComponent } from '../../../layout/svg-spinner/svg-spinner.component';
import { DetailPanelComponent } from '../../detail-panel/detail-panel.component';
import { LijstComponent } from '../../lijst/lijst.component';
import { InstantSearchBoxComponent } from '@cumlaude/shared-components-inputs';
import { UserTabMenuComponent } from '../../../layout/user-tab-menu/user-tab-menu.component';
import { SelectionBarComponent } from '../../../filter-bar/selection-bar.component';
import { ClickBlockingOverlayComponent } from '../../../layout/click-blocking-overlay/click-blocking-overlay.component';
import { DashboardActiesComponent } from '../../../layout/dashboard-acties/dashboard-acties.component';
import { TabMenuComponent } from '@cumlaude/shared-components-menu';

const lijstDataCol: Attr[][] = [
	['mw_nm_achternaam'],
	['mw_nm_voorvoegsel'],
	['mw_nm_roepnaam'],
	['mw_abb_medewerker'],
	['mw_id_medewerker'],
	['mw_pic_pasfoto'],
];

const detailsDataCol: Attr[][] = [...lijstDataCol, ['mw_d_indienst'], ['mw_fun_d_uitdienst'], ['mw_fun_nr_dienstjaren']];

@Component({
	selector: 'app-docent-details-panel',
	templateUrl: '../../base-details-panel/base-details-panel.component.html',
	styleUrls: ['../../base-details-panel/base-details-panel.component.scss'],
	imports: [
		UserTabMenuComponent,
		TabMenuComponent,
		DashboardActiesComponent,
		InstantSearchBoxComponent,
		LijstComponent,
		DetailPanelComponent,
		SvgSpinnerComponent,
		RouterOutlet,
		AsyncPipe,
		SelectionBarComponent,
		ClickBlockingOverlayComponent,
	],
})
export class DocentDetailsPanelComponent extends BaseDetailsPanelComponent<Medewerker, MedewerkerDetail> {
	getTitle(): string {
		return 'Medewerkers';
	}

	getType(): string {
		return 'medewerker';
	}

	getUrlPart(): string {
		return '/details/docent';
	}

	getElementKey(element: Medewerker) {
		return element.mw_id_medewerker;
	}

	getFilters(searchInput: string): CompoundFilterExpression | undefined {
		if (searchInput === '') return undefined;

		return new CompoundFilterExpression(
			[
				new BasicFilterExpression(['mw_abb_medewerker'], `%${searchInput}%`, 'like'),
				new BasicFilterExpression(['mw_fun_volledige_naam'], `%${searchInput}%`, 'like_unaccent'),
			],
			'or'
		);
	}

	isSelectionVisible() {
		return false;
	}

	/**
	 * Alleen de docentselectie ('adhoc-docent') geldt hier: een leerlingselectie ('adhoc') kan niet op medewerkers filteren.
	 */
	protected override getSelectieExpressions(): Observable<FilterExpression[]> {
		return this.leerlingSelectieService.adHocDocentSelectie$.pipe(map((selectie) => (selectie ? [selectie.expression] : [])));
	}

	getLijstData(options: Partial<ListOptions>): Observable<TableResponse<Medewerker>> {
		return this.dataService.getMedewerkers<Medewerker>({ ...options, col: lijstDataCol });
	}

	getDetailsData(key: number): Observable<TableResponse<MedewerkerDetail>> {
		return this.dataService.getMedewerkerDetails<MedewerkerDetail>(detailsDataCol, key);
	}

	getLijstElementData(input: Medewerker): LijstElementData {
		const title = roepAchternaam(input);
		return {
			title,
			subTitle: input.mw_abb_medewerker,
			pasfoto: input.mw_pic_pasfoto,
		};
	}

	getDetailsElementData(input: MedewerkerDetail): DetailsElementData {
		const details = <ElementDataDetail[]>[{ label: attrLabel(['mw_d_indienst']), waarde: convertDate(input.mw_d_indienst) }];

		if (convertDate(input.mw_fun_d_uitdienst) != '-')
			details.push({ label: attrLabel(['mw_fun_d_uitdienst']), waarde: convertDate(input.mw_fun_d_uitdienst) });

		details.push({ label: attrLabel(['mw_fun_nr_dienstjaren']), waarde: input.mw_fun_nr_dienstjaren.toString() });

		const title = [input.mw_nm_roepnaam, input.mw_nm_voorvoegsel, input.mw_nm_achternaam].filter(Boolean).join(' ');
		return {
			title,
			subTitle: [input.mw_abb_medewerker],
			pasfoto: input.mw_pic_pasfoto,
			details,
		};
	}
}
